import { mapActions } from 'pinia';
import usePlanningElementsStore from '@/stores/planning/elements';
import useSelectionStore from '@/stores/selection';
import useUiPlanningStore from '@/stores/ui/planning';

export default {
  data() {
    return {
      selectionStore: useSelectionStore(),
      uiPlanningStore: useUiPlanningStore(),
    };
  },
  computed: {
    selection() { return this.selectionStore.selection; },
  },
  methods: {
    droppableConfig(lane) {
      if (! this.canModifyLane(lane)) return { enabled: false };
      const vm = this;
      return {
        enabled: ! lane.hidden,
        accept: '.element',
        ondrop(event) {
          vm.dropSelection(event, lane);
        },
        ondragenter(event) {
          vm.dropOver(event, lane);
        },
        ondragleave(event) {
          vm.dropOut(event, lane);
        },
      };
    },

    dropOver(event, lane) {
      const dragData = event.relatedTarget.dragData || {};
      if (dragData.livedragActive) {
        $(`#el${dragData.placeholderId}`).show();
        const placeholderEl = this.planning.elements.find(el => el.id == dragData.placeholderId);
        if (placeholderEl) placeholderEl.setLaneId(lane.id);
      }
    },

    dropOut(event, lane) {
      const dragData = event.relatedTarget.dragData || {};
      if (dragData.livedragActive) {
        const placeholderEl = this.planning.elements.find(el => el.id == dragData.placeholderId);
        if (placeholderEl && placeholderEl.getLaneId() == lane.id) $(`#el${dragData.placeholderId}`).hide();
      }
    },

    dropSelection(event, lane) {
      const dragData = event.relatedTarget.dragData || {};
      const draggedEl = this.planning.elements.find(el => el.id == dragData.id);
      if (! draggedEl) return;

      const initialState = { laneId: draggedEl.getLaneId(), processStep: draggedEl.getProcessStep() };
      let saveAllElements = false;
      const positionX = dragData.position.left - dragData.cursorOffset.x - dragData.laneXOffset;
      if (this.uiPlanningStore.mode == 'kanban') {
        const referenceXPosition = positionX + dragData.cloneDimensions.width / 2;
        const referenceYPosition = dragData.position.top + dragData.cloneDimensions.height / 2;
        const modifiedElements = draggedEl.kanbanMove(lane.id, referenceXPosition, referenceYPosition); // x relative to lane, y relative to page
        if (modifiedElements && modifiedElements.length > 1) saveAllElements = true;
      } else {
        draggedEl.move(lane.id, dragData.position.left - dragData.cursorOffset.x - dragData.laneXOffset); // x relative to lane
      }

      if (this.selection.size > 1) {
        // other elements in selection drag
        let offsetLane = 0;
        if (lane.id != initialState.laneId) offsetLane = this.planning.lanes.findIndex(item => item.id == lane.id) - this.planning.lanes.findIndex(item => item.id == initialState.laneId);
        let offsetProcessStep = 0;
        if (draggedEl.getProcessStep() != initialState.processStep) { // draggedEl already updated above -> compare with initialState.processStep
          const planningSteps = this.planning.process.steps;
          offsetProcessStep = planningSteps.findIndex(item => item.id == draggedEl.getProcessStep()) - planningSteps.findIndex(item => item.id == initialState.processStep);
        }

        this.selection.forEach((selectedId) => {
          const selectedEl = this.planning.elements.find(el => el.id == selectedId);
          if (! selectedEl || selectedEl.id == draggedEl.id) return;

          let newlaneId = selectedEl.getLaneId();
          if (offsetLane) {
            let newlaneIndex = this.planning.lanes.findIndex(item => item.id === selectedEl.getLaneId()) + offsetLane;
            // if getting out of visible, stop to last lane
            while (! this.planning.lanes[newlaneIndex]) newlaneIndex -= offsetLane / Math.abs(offsetLane);
            newlaneId = this.planning.lanes[newlaneIndex].id;
          }

          if (this.uiPlanningStore.mode == 'kanban') {
            selectedEl.setLaneId(newlaneId);
            if (offsetProcessStep) {
              let newProcessStepIndex = this.planning.process.steps.findIndex(item => item.id === selectedEl.getProcessStep()) + offsetProcessStep;
              // if getting out of visible, stop to last step
              while (! this.planning.process.steps[newProcessStepIndex]) newProcessStepIndex -= offsetProcessStep / Math.abs(offsetProcessStep);
              selectedEl.setProcessStep(this.planning.process.steps[newProcessStepIndex].id);
            }
          } else {
            const selectedElLeftPosition = $(`#el${selectedEl.id}`).position().left;
            selectedEl.move(newlaneId, selectedElLeftPosition);
          }
        });
        saveAllElements = true;
      }

      if (saveAllElements) {
        setTimeout(() => { this.changingElement(); });
      } else {
        setTimeout(() => { this.changingElement(draggedEl); }); // timeout needed when xposition is programmaticaly set back to initial value
      }
      this.uiPlanningStore.doNotUpdateSelection = false;
    },
    ...mapActions(usePlanningElementsStore, ['changingElement']),
  },
};
